import { formatDate } from '@angular/common';

import { StatusPillVariant } from '../../../shared/ui/status-pill/status-pill.component';
import { roundAmount } from '../../../shared/round-amount';

export interface InvestmentPaymentAmounts {
  total: number;
  paid: number;
  pending: number;
  paidDate?: string | Date | null;
}

export function investmentMoney(value: number): number {
  return roundAmount(value);
}

export function investmentPaymentVariant(amounts: InvestmentPaymentAmounts | null): StatusPillVariant {
  if (!amounts || !(Number(amounts.total) > 0)) return 'neutral';
  if (investmentMoney(amounts.pending) <= 0) return 'success';
  return Number(amounts.paid) > 0 ? 'info' : 'warning';
}

export function investmentPaymentLabel(amounts: InvestmentPaymentAmounts | null): string {
  if (!amounts || !(Number(amounts.total) > 0)) return 'Sin importe';
  if (investmentMoney(amounts.pending) <= 0) {
    const date = investmentDateLabel(amounts.paidDate);
    return date ? 'Pagada ' + date : 'Pagada';
  }
  return Number(amounts.paid) > 0 ? 'Pago parcial' : 'Pendiente';
}

export function investmentDateLabel(value: string | Date | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    return value === '01/01/0001' ? '' : value;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime()) || date.getFullYear() <= 1) return '';
  return formatDate(date, 'dd/MM/yyyy', 'es-ES');
}
